import { WOOD_SORTS, WOOD_GRADES, woodVol, num } from '../lib/woodList';

const nf = (v) => v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// wood pile entry: species, assortment, RVR grade (or free text), length, mid diameter, pieces -> Festmeter
export default function WoodFields({ t, data, set }) {
  const d = data || {};
  const up = (k, v) => set({ ...d, [k]: v });
  const other = d.grade != null && d.grade !== '' && !WOOD_GRADES.includes(d.grade);
  const auto = num(d.len) > 0 && num(d.dia) > 0;
  const inp = (k, mode = 'decimal') => <input data-testid={`wp-field-${k}`} inputMode={mode} value={d[k] ?? ''} onChange={(e) => up(k, e.target.value)} />;
  return (
    <div className="wp-st wp-fields" data-testid="wp-fields">
      <label>{t.wpF_species}{inp('species', 'text')}</label>
      <label>{t.wpF_sort}
        <select data-testid="wp-field-sort" value={d.sort || ''} onChange={(e) => up('sort', e.target.value)}>
          <option value="">–</option>
          {WOOD_SORTS.map((s) => <option key={s} value={t['woodSort_' + s]}>{t['woodSort_' + s]}</option>)}
        </select>
      </label>
      <label>{t.wpF_grade}
        <select data-testid="wp-field-grade" value={other ? '__other' : d.grade || ''} onChange={(e) => up('grade', e.target.value === '__other' ? ' ' : e.target.value)}>
          <option value="">–</option>
          {WOOD_GRADES.map((g) => <option key={g} value={g}>{t.woodGrade} {g}</option>)}
          <option value="__other">{t.woodGradeOther}</option>
        </select>
      </label>
      {other && <label>{t.woodGradeOther}<input data-testid="wp-field-grade-text" value={d.grade.trimStart()} onChange={(e) => up('grade', e.target.value || ' ')} /></label>}
      <label>{t.wpF_len}{inp('len')}</label>
      <label>{t.wpF_dia}{inp('dia')}</label>
      <label>{t.wpF_count}{inp('count', 'numeric')}</label>
      {auto
        ? <label>{t.wpF_volume}<output className="wp-auto" data-testid="wp-field-volume-auto">{nf(woodVol(d))} fm</output></label>
        : <label>{t.wpF_volume}{inp('volume')}</label>}
      <small className="muted" data-testid="wp-wood-hint">{t.woodAutoHint}</small>
    </div>
  );
}
